import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface LabelProps {
  htmlFor?: string;
  text: string | ReactNode;
  isInverted?: boolean;
  isGrey?: boolean;
  testId?: string;
  isRequired?: boolean;
}

export const Label = ({
  htmlFor,
  text,
  isInverted,
  isGrey,
  testId,
  isRequired,
}: LabelProps) => (
  <LabelWrapper
    htmlFor={htmlFor}
    data-test-id={testId}
    isInverted={isInverted}
    isGrey={isGrey}
    isRequired={isRequired}
  >
    {text}
  </LabelWrapper>
);

type LabelWrapperProps = {
  isInverted?: boolean;
  isGrey?: boolean;
  isRequired?: boolean;
};

const LabelWrapper = styled.label<LabelWrapperProps>`
  text-transform: uppercase;
  font-size: 11.5px;
  line-height: 15px;
  margin-bottom: 2px;
  letter-spacing: 0.3px;
  ${({ theme }) => theme?.overrides?.Label}

  ${({ isInverted }) =>
    isInverted &&
    css`
      color: ${({ theme: { colors } }) => colors?.invertedDefault};
      font-weight: 600;
    `}

  ${({ isGrey }) =>
    isGrey &&
    css`
      color: ${({ theme: { colors } }) => colors?.primerGrey};
    `}

  ${({ isRequired }) =>
    isRequired &&
    css`
      &: after {
        content: '*';
        color: ${({ theme: { colors } }) => colors?.darkRed};
        padding-left: 2px;
      }
    `}
`;
